import { ThemeConfig } from 'antd/lib'

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1c64f2',
    colorError: '#e02424',
    colorTextDescription: '#041433',
    borderRadius: 6,
    fontSize: 14,
  },
  components: {
    Switch: {
      colorTextQuaternary: '#d9dfe7',
      colorTextTertiary: '#cad1d8',
    },
    Dropdown: {
      zIndexPopup: 10000,
    },
    Tooltip: {
      colorBgSpotlight: '#000',
    },
    Empty: {
      colorTextDescription: '#6b7280',
    },
    DatePicker: {
      controlHeight: 38,
    },
    Button: {
      colorPrimary: '#1c64f2',
      defaultColor: '#6b7280',
      primaryShadow: 'none',
      colorLink: '#1c64f2',
      borderRadius: 6,
      fontWeight: 500,
      fontSize: 16,
      paddingInline: 24,
      paddingInlineLG: 24,
      paddingInlineSM: 24,
      controlHeight: 42,
    },
    Checkbox: {
      borderRadiusSM: 4,
    },
    Radio: {
      colorBgContainer: 'transparent',
      buttonSolidCheckedBg: '#1c64f2',
      buttonSolidCheckedHoverBg: '#1c64f2',
      buttonPaddingInline: 16,
      borderRadius: 40,
      colorBorder: '#dee2e6',
    },
    Form: {
      itemMarginBottom: 8,
      labelColor: '#374151',
      labelFontSize: 16,
    },
    Select: {
      controlHeight: 38,
      colorBorder: '#dee2e6',
      hoverBorderColor: '#dee2e6',
    },
    Input: {
      addonBg: '#1c64f2',
      colorFillAlter: '#1c64f2',
      hoverBorderColor: '#dee2e6',
      colorBorder: '#dee2e6',
      colorBgContainer: 'transparent',
      controlHeight: 38,
    },
    TreeSelect: {
      indentSize: 8,
      controlInteractiveSize: 35,
      colorTextDisabled: 'rgba(0,0,0,0.4)',
      borderRadius: 6,
    },
    Modal: {
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      titleFontSize: 22,
    },
  },
}

export default antdTheme
